import {BaseObject} from './BaseObject';

export class ContractItemTransfer extends BaseObject {

    public static OUT = 'out';
    public static IN = 'in';

    contractItemId: number;
    count: number;
    direction = ContractItemTransfer.OUT;
    force = false;
    userId = 1;

}



// WEBPACK FOOTER //
// /app/src/model/Entities/ContractItemTransfer.ts